import React from "react";
import { Link } from "react-router-dom";

export function PageHero({ eyebrow, title, subtitle, image, testid }) {
  return (
    <section className="relative h-[68vh] min-h-[520px] w-full overflow-hidden" data-testid={testid}>
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 hero-overlay"></div>
      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-10 w-full">
          {eyebrow && <p className="eyebrow text-primary mb-5">{eyebrow}</p>}
          <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] max-w-3xl">{title}</h1>
          {subtitle && <p className="text-white/85 text-lg md:text-xl mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
        </div>
      </div>
    </section>
  );
}

export function CtaBanner({ title, subtitle, ctaTo = "/contact", ctaLabel = "Book a Free Chat", testid }) {
  return (
    <section className="section-pad bg-cream text-center" data-testid={testid}>
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="font-serif text-4xl md:text-5xl mb-5">{title}</h2>
        {subtitle && <p className="text-warmgrey text-lg mb-10">{subtitle}</p>}
        <Link to={ctaTo} className="btn-primary">{ctaLabel}</Link>
      </div>
    </section>
  );
}
